import type { components } from '@heidi/schema/ml-scribe';
import { useMutation } from '@tanstack/react-query';

import { ehrMutationKeys } from '../../contracts/queryKeys';

type SessionUpdate = components['schemas']['SessionUpdate'];

type AppointmentVariables = {
  sessionId: string;
  EHRApptId: string;
  createdTimeLocal: string;
  ehrProvider?: string;
  ehrPatientId?: string;
  ehrEncounterId?: string;
};

export function useMutateUpdateSessionEHRAppointmentId<TResult>(options: {
  updateSession: (sessionId: string, body: SessionUpdate) => Promise<TResult>;
  onMutate?: (variables: AppointmentVariables) => unknown;
  onSuccess?: (res: TResult) => void;
  onError?: (error: unknown) => void;
}) {
  return useMutation({
    mutationKey: ehrMutationKeys.updateSessionEhrAppointmentId(),
    mutationFn: async ({
      sessionId,
      EHRApptId,
      createdTimeLocal,
      ehrProvider,
      ehrPatientId,
      ehrEncounterId,
    }: AppointmentVariables) => {
      return await options.updateSession(sessionId, {
        ehr_appt_id: EHRApptId,
        created_time_local: createdTimeLocal,
        ehr_provider: ehrProvider,
        ...(ehrPatientId && { ehr_patient_id: ehrPatientId }),
        ...(ehrEncounterId && { ehr_encounter_id: ehrEncounterId }),
      });
    },
    onMutate: options.onMutate,
    onSuccess: options.onSuccess,
    onError: options.onError,
  });
}
